import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetCustomersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CustomersSummaryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.CustomersSummaryDocumentSortInput> | Types.CustomersSummaryDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCustomersQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'CustomersSummaryDocument', id: string, erpId: string, importId: string, crmImportId: string, crmRecordUrl: string, erpPriceGroupId?: string | null, tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, priceGroupName?: string | null, route: string, termsId?: string | null, termsName?: string | null, customerTypeId?: string | null, customerTypeName?: string | null, customerGroupId?: string | null, customerGroupName?: string | null, dateCreated: Types.TDateISO, numberOfLocations: number, numberOfBillingAddresses: number, numberOfContacts: number, numberOfShipFromLocations: number, numberOfNotes: number, shipToStates: Array<string>, history: Array<string>, synchronizeOrders: boolean, customerLookupCode: string, usageCount?: number | null, carrier: string, freightChargeType?: number | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, taxExemptNumber: string, federalTaxNumber: string, poRequired: boolean, primaryContactPhone: string, effectiveOrderEntryUnit: Types.OrderEntryUnit, contactSearchEntries: Array<{ __typename?: 'CustomerContactSearchEntry', contactId: string, name: string, phone: string, phoneDigits: string }> }> | null } | null };

export type GetCustomersByNamesQueryVariables = Types.Exact<{
  names: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  where?: Types.InputMaybe<Types.CustomersSummaryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.CustomersSummaryDocumentSortInput> | Types.CustomersSummaryDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCustomersByNamesQuery = { __typename?: 'Query', customersByNames?: { __typename?: 'CustomersByNamesConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomersSummaryDocument', customerId: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCustomerIdentitiesByNamesQueryVariables = Types.Exact<{
  names: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  order?: Types.InputMaybe<Array<Types.CustomersSummaryDocumentSortInput> | Types.CustomersSummaryDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCustomerIdentitiesByNamesQuery = { __typename?: 'Query', customersByNames?: { __typename?: 'CustomersByNamesConnection', nodes?: Array<{ __typename?: 'CustomersSummaryDocument', customerId: string, name: string, customerTypeId?: string | null, erpId: string, importId: string, crmImportId: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCustomersTermsByIdsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CustomersSummaryDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetCustomersTermsByIdsQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomersSummaryDocument', customerId: string, termsId?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCustomersPoRequiredByIdsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CustomersSummaryDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetCustomersPoRequiredByIdsQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomersSummaryDocument', customerId: string, poRequired: boolean }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCustomerNamesForUserAdminQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CustomersSummaryDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetCustomerNamesForUserAdminQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomersSummaryDocument', customerId: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCustomerQueryVariables = Types.Exact<{
  customerId: Types.Scalars['String']['input'];
}>;


export type GetCustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null };

export type GetCustomersForImportQueryVariables = Types.Exact<{
  customerIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCustomersForImportQuery = { __typename?: 'Query', customersForImport?: { __typename?: 'CustomersForImportConnection', nodes?: Array<{ __typename?: 'CustomerStateData', customerId: string, name: string, currency: string, description: string, erpId: string, erpPriceGroupId: string, priceGroupId: string, termsId: string, customerTypeId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, taxExemptNumber: string, federalTaxNumber: string, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, termsId?: string | null, route?: string | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCustomerOrderContactsForImportQueryVariables = Types.Exact<{
  customerIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCustomerOrderContactsForImportQuery = { __typename?: 'Query', customersForImport?: { __typename?: 'CustomersForImportConnection', nodes?: Array<{ __typename?: 'CustomerStateData', customerId: string, contacts: Array<{ __typename?: 'ContactData', type: Types.ContactType, emailAddresses: Array<{ __typename?: 'EmailAddressData', value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', value: string }> }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', phone?: string | null, email?: string | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCustomersOwnBillingAddressForImportQueryVariables = Types.Exact<{
  customerIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCustomersOwnBillingAddressForImportQuery = { __typename?: 'Query', customersForImport?: { __typename?: 'CustomersForImportConnection', nodes?: Array<{ __typename?: 'CustomerStateData', customerId: string, hasOwnBillingAddress: boolean }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCustomersImportReadinessForErpQueryVariables = Types.Exact<{
  customerIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCustomersImportReadinessForErpQuery = { __typename?: 'Query', customersForImport?: { __typename?: 'CustomersForImportConnection', nodes?: Array<{ __typename?: 'CustomerStateData', customerId: string, hasOwnBillingAddress: boolean, locations: Array<{ __typename?: 'LocationData', id: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCustomerInvoiceRecipientsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['String']['input'];
}>;


export type GetCustomerInvoiceRecipientsQuery = { __typename?: 'Query', customerInvoiceRecipients?: { __typename?: 'CustomerInvoiceRecipientsData', recipients: Array<string>, fallbackReason: Types.CustomerRecipientFallbackReason } | null };

export type CustomerLocationsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.CustomerLocationDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.CustomerLocationDocumentSortInput> | Types.CustomerLocationDocumentSortInput>;
}>;


export type CustomerLocationsQuery = { __typename?: 'Query', customerLocations?: { __typename?: 'CustomerLocationsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'CustomerLocationDocument', adGroup: string, id: string, tenantId: string, customerId: string, customerName: string, customerLookupCode: string, globalLocationNumber: string, locationId: string, locationLookupCode: string, name: string, code: string, storeNumber: string, region: string, priceGroupId: string, priceGroupName: string, route: string, termsId: string, termsName: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: number | null, freightChargeValue?: number | null, poRequired?: boolean | null, market: string, servicingSiteLocationId: string, latitude?: number | null, longitude?: number | null, receivingEmail?: string | null, effectiveReceivingWindowStart?: string | null, effectiveReceivingWindowEnd?: string | null, address?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, settings?: { __typename?: 'CustomerLocationSettingsDocument', deliveryScheduleId: string, deliveryScheduleName: string, retailerName: string, route: string, shippingNotes: string, storeClass: string, zone: string, ruleIds: Array<string>, notes: Array<{ __typename?: 'CustomerLocationNoteDocument', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }>, contextNotes: Array<{ __typename?: 'CustomerLocationContextNoteDocument', context: Types.NoteContext, submitDate: Types.TDateISO, submittedBy: string, text: string }> } | null }> | null } | null };

export type GetCustomerLocationsForSelectorQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.CustomerLocationDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.CustomerLocationDocumentSortInput> | Types.CustomerLocationDocumentSortInput>;
}>;


export type GetCustomerLocationsForSelectorQuery = { __typename?: 'Query', customerLocations?: { __typename?: 'CustomerLocationsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'CustomerLocationDocument', id: string, locationId: string, name: string, code: string, locationLookupCode: string, priceGroupName: string, customerLookupCode: string, customerName: string, region: string, storeNumber: string, route: string, latitude?: number | null, longitude?: number | null, address?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, settings?: { __typename?: 'CustomerLocationSettingsDocument', deliveryScheduleId: string, route: string, storeClass: string, zone: string } | null }> | null } | null };

export type GetCustomerLocationNamesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.CustomerLocationDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.CustomerLocationDocumentSortInput> | Types.CustomerLocationDocumentSortInput>;
  includeCombined?: Types.Scalars['Boolean']['input'];
}>;


export type GetCustomerLocationNamesQuery = { __typename?: 'Query', customerLocations?: { __typename?: 'CustomerLocationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomerLocationDocument', locationId: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCustomerLocationsWithBaseRateOfSaleQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.CustomerLocationDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.CustomerLocationDocumentSortInput> | Types.CustomerLocationDocumentSortInput>;
}>;


export type GetCustomerLocationsWithBaseRateOfSaleQuery = { __typename?: 'Query', customerLocationsWithBaseRateOfSale?: { __typename?: 'CustomerLocationsWithBaseRateOfSaleConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'CustomerLocationDocument', id: string, locationId: string, name: string, code: string, locationLookupCode: string, priceGroupName: string, customerLookupCode: string, customerName: string, region: string, storeNumber: string, route: string, latitude?: number | null, longitude?: number | null, address?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, settings?: { __typename?: 'CustomerLocationSettingsDocument', deliveryScheduleId: string, route: string, storeClass: string, zone: string } | null }> | null } | null };

export type CustomerTaxExemptionFragment = { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null };

export type CustomerFragment = { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null };

export type CustomerUpgradeFieldsFragment = { __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null };

export type ContactFragment = { __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> };

export type BillingAddressesFragment = { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string };

export type CustomerNodesFragment = { __typename?: 'CustomersConnection', nodes?: Array<{ __typename?: 'CustomersSummaryDocument', id: string, erpId: string, importId: string, crmImportId: string, crmRecordUrl: string, erpPriceGroupId?: string | null, tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, priceGroupName?: string | null, route: string, termsId?: string | null, termsName?: string | null, customerTypeId?: string | null, customerTypeName?: string | null, customerGroupId?: string | null, customerGroupName?: string | null, dateCreated: Types.TDateISO, numberOfLocations: number, numberOfBillingAddresses: number, numberOfContacts: number, numberOfShipFromLocations: number, numberOfNotes: number, shipToStates: Array<string>, history: Array<string>, synchronizeOrders: boolean, customerLookupCode: string, usageCount?: number | null, carrier: string, freightChargeType?: number | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, taxExemptNumber: string, federalTaxNumber: string, poRequired: boolean, primaryContactPhone: string, effectiveOrderEntryUnit: Types.OrderEntryUnit, contactSearchEntries: Array<{ __typename?: 'CustomerContactSearchEntry', contactId: string, name: string, phone: string, phoneDigits: string }> }> | null };

export type CustomerFullFragment = { __typename?: 'CustomersSummaryDocument', id: string, erpId: string, importId: string, crmImportId: string, crmRecordUrl: string, erpPriceGroupId?: string | null, tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, priceGroupName?: string | null, route: string, termsId?: string | null, termsName?: string | null, customerTypeId?: string | null, customerTypeName?: string | null, customerGroupId?: string | null, customerGroupName?: string | null, dateCreated: Types.TDateISO, numberOfLocations: number, numberOfBillingAddresses: number, numberOfContacts: number, numberOfShipFromLocations: number, numberOfNotes: number, shipToStates: Array<string>, history: Array<string>, synchronizeOrders: boolean, customerLookupCode: string, usageCount?: number | null, carrier: string, freightChargeType?: number | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, taxExemptNumber: string, federalTaxNumber: string, poRequired: boolean, primaryContactPhone: string, effectiveOrderEntryUnit: Types.OrderEntryUnit, contactSearchEntries: Array<{ __typename?: 'CustomerContactSearchEntry', contactId: string, name: string, phone: string, phoneDigits: string }> };

export type CustomerContactSearchEntryFragment = { __typename?: 'CustomerContactSearchEntry', contactId: string, name: string, phone: string, phoneDigits: string };

export type CustomerIdentityFragment = { __typename?: 'CustomerStateData', customerId: string };

export type ChangedCustomerFragment = { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, description: string, currency: string, status: Types.CustomerStatus, sendOrderEmails: boolean, sendInvoiceEmails: boolean, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null };

export type OrderSubmitterFragment = { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null };

export type CustomerLocationSelectorFieldsFragment = { __typename?: 'CustomerLocationDocument', id: string, locationId: string, name: string, code: string, locationLookupCode: string, priceGroupName: string, customerLookupCode: string, customerName: string, region: string, storeNumber: string, route: string, latitude?: number | null, longitude?: number | null, address?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, settings?: { __typename?: 'CustomerLocationSettingsDocument', deliveryScheduleId: string, route: string, storeClass: string, zone: string } | null };

export type CustomerLocationFieldsFragment = { __typename?: 'CustomerLocationDocument', adGroup: string, id: string, tenantId: string, customerId: string, customerName: string, customerLookupCode: string, globalLocationNumber: string, locationId: string, locationLookupCode: string, name: string, code: string, storeNumber: string, region: string, priceGroupId: string, priceGroupName: string, route: string, termsId: string, termsName: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: number | null, freightChargeValue?: number | null, poRequired?: boolean | null, market: string, servicingSiteLocationId: string, latitude?: number | null, longitude?: number | null, receivingEmail?: string | null, effectiveReceivingWindowStart?: string | null, effectiveReceivingWindowEnd?: string | null, address?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, settings?: { __typename?: 'CustomerLocationSettingsDocument', deliveryScheduleId: string, deliveryScheduleName: string, retailerName: string, route: string, shippingNotes: string, storeClass: string, zone: string, ruleIds: Array<string>, notes: Array<{ __typename?: 'CustomerLocationNoteDocument', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }>, contextNotes: Array<{ __typename?: 'CustomerLocationContextNoteDocument', context: Types.NoteContext, submitDate: Types.TDateISO, submittedBy: string, text: string }> } | null };

export type GetEffectiveDeliveryScheduleQueryVariables = Types.Exact<{
  customerId: Types.Scalars['String']['input'];
  locationId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type GetEffectiveDeliveryScheduleQuery = { __typename?: 'Query', effectiveDeliverySchedule?: { __typename?: 'EffectiveDeliveryScheduleData', tier: Types.DeliveryScheduleTier, restrictionActive: boolean, effectiveRoute?: string | null, deliveryScheduleId?: string | null, deliveryScheduleName?: string | null, sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null };

export type EffectiveDeliveryScheduleFieldsFragment = { __typename?: 'EffectiveDeliveryScheduleData', tier: Types.DeliveryScheduleTier, restrictionActive: boolean, effectiveRoute?: string | null, deliveryScheduleId?: string | null, deliveryScheduleName?: string | null, sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean };

export type GetCustomerMinimumFreightQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  where: Types.CustomersSummaryDocumentFilterInput;
}>;


export type GetCustomerMinimumFreightQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomersSummaryDocument', customerId: string, minimumFreightCharge?: number | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const CustomerTaxExemptionFragmentDoc = new TypedDocumentString(`
    fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
    `, {"fragmentName":"CustomerTaxExemption"});
export const BillingAddressesFragmentDoc = new TypedDocumentString(`
    fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
    `, {"fragmentName":"BillingAddresses"});
export const ContactFragmentDoc = new TypedDocumentString(`
    fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
    `, {"fragmentName":"Contact"});
export const CustomerUpgradeFieldsFragmentDoc = new TypedDocumentString(`
    fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
    `, {"fragmentName":"CustomerUpgradeFields"});
export const OrderSubmitterFragmentDoc = new TypedDocumentString(`
    fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}
    `, {"fragmentName":"OrderSubmitter"});
export const CustomerFragmentDoc = new TypedDocumentString(`
    fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
    fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}`, {"fragmentName":"Customer"});
export const CustomerContactSearchEntryFragmentDoc = new TypedDocumentString(`
    fragment CustomerContactSearchEntry on CustomerContactSearchEntry {
  contactId
  name
  phone
  phoneDigits
}
    `, {"fragmentName":"CustomerContactSearchEntry"});
export const CustomerFullFragmentDoc = new TypedDocumentString(`
    fragment CustomerFull on CustomersSummaryDocument {
  id
  erpId
  importId
  crmImportId
  crmRecordUrl
  erpPriceGroupId
  tenantId
  customerId
  name
  currency
  status
  priceGroupName
  route
  termsId
  termsName
  customerTypeId
  customerTypeName
  customerGroupId
  customerGroupName
  dateCreated
  numberOfLocations
  numberOfBillingAddresses
  numberOfContacts
  numberOfShipFromLocations
  numberOfNotes
  shipToStates
  history
  synchronizeOrders
  customerLookupCode
  usageCount
  carrier
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  taxExemptNumber
  federalTaxNumber
  poRequired
  poRequired
  shipToStates
  primaryContactPhone
  effectiveOrderEntryUnit
  contactSearchEntries {
    ...CustomerContactSearchEntry
  }
}
    fragment CustomerContactSearchEntry on CustomerContactSearchEntry {
  contactId
  name
  phone
  phoneDigits
}`, {"fragmentName":"CustomerFull"});
export const CustomerNodesFragmentDoc = new TypedDocumentString(`
    fragment CustomerNodes on CustomersConnection {
  nodes {
    ...CustomerFull
  }
}
    fragment CustomerFull on CustomersSummaryDocument {
  id
  erpId
  importId
  crmImportId
  crmRecordUrl
  erpPriceGroupId
  tenantId
  customerId
  name
  currency
  status
  priceGroupName
  route
  termsId
  termsName
  customerTypeId
  customerTypeName
  customerGroupId
  customerGroupName
  dateCreated
  numberOfLocations
  numberOfBillingAddresses
  numberOfContacts
  numberOfShipFromLocations
  numberOfNotes
  shipToStates
  history
  synchronizeOrders
  customerLookupCode
  usageCount
  carrier
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  taxExemptNumber
  federalTaxNumber
  poRequired
  poRequired
  shipToStates
  primaryContactPhone
  effectiveOrderEntryUnit
  contactSearchEntries {
    ...CustomerContactSearchEntry
  }
}
fragment CustomerContactSearchEntry on CustomerContactSearchEntry {
  contactId
  name
  phone
  phoneDigits
}`, {"fragmentName":"CustomerNodes"});
export const CustomerIdentityFragmentDoc = new TypedDocumentString(`
    fragment CustomerIdentity on CustomerStateData {
  customerId
}
    `, {"fragmentName":"CustomerIdentity"});
export const ChangedCustomerFragmentDoc = new TypedDocumentString(`
    fragment ChangedCustomer on CustomerPayload {
  customer {
    tenantId
    customerId
    name
    description
    currency
    status
    sendOrderEmails
    sendInvoiceEmails
    salesPeople {
      ...SalesPerson
    }
    locations {
      ...Location
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}`, {"fragmentName":"ChangedCustomer"});
export const CustomerLocationSelectorFieldsFragmentDoc = new TypedDocumentString(`
    fragment CustomerLocationSelectorFields on CustomerLocationDocument {
  id
  locationId
  name
  code
  locationLookupCode
  priceGroupName
  customerLookupCode
  customerName
  region
  storeNumber
  route
  latitude
  longitude
  address {
    ...AddressData
  }
  settings {
    deliveryScheduleId
    route
    storeClass
    zone
  }
}
    fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`, {"fragmentName":"CustomerLocationSelectorFields"});
export const CustomerLocationFieldsFragmentDoc = new TypedDocumentString(`
    fragment CustomerLocationFields on CustomerLocationDocument {
  adGroup
  id
  tenantId
  customerId
  customerName
  customerLookupCode
  globalLocationNumber
  locationId
  locationLookupCode
  name
  code
  storeNumber
  region
  priceGroupId
  priceGroupName
  route
  termsId
  termsName
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  poRequired
  market
  region
  servicingSiteLocationId
  latitude
  longitude
  receivingEmail
  effectiveReceivingWindowStart
  effectiveReceivingWindowEnd
  address {
    ...AddressData
  }
  settings {
    deliveryScheduleId
    deliveryScheduleName
    retailerName
    route
    shippingNotes
    storeClass
    zone
    deliveryScheduleName
    deliveryScheduleId
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    contextNotes {
      context
      submitDate
      submittedBy
      text
    }
    ruleIds
    shippingNotes
  }
  customerLookupCode
  locationLookupCode
}
    fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`, {"fragmentName":"CustomerLocationFields"});
export const EffectiveDeliveryScheduleFieldsFragmentDoc = new TypedDocumentString(`
    fragment EffectiveDeliveryScheduleFields on EffectiveDeliveryScheduleData {
  tier
  restrictionActive
  effectiveRoute
  deliveryScheduleId
  deliveryScheduleName
  sunday
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
}
    `, {"fragmentName":"EffectiveDeliveryScheduleFields"});
export const GetCustomersDocument = new TypedDocumentString(`
    query GetCustomers($where: CustomersSummaryDocumentFilterInput, $order: [CustomersSummaryDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  customers(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    ...CustomerNodes
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment CustomerNodes on CustomersConnection {
  nodes {
    ...CustomerFull
  }
}
fragment CustomerFull on CustomersSummaryDocument {
  id
  erpId
  importId
  crmImportId
  crmRecordUrl
  erpPriceGroupId
  tenantId
  customerId
  name
  currency
  status
  priceGroupName
  route
  termsId
  termsName
  customerTypeId
  customerTypeName
  customerGroupId
  customerGroupName
  dateCreated
  numberOfLocations
  numberOfBillingAddresses
  numberOfContacts
  numberOfShipFromLocations
  numberOfNotes
  shipToStates
  history
  synchronizeOrders
  customerLookupCode
  usageCount
  carrier
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  taxExemptNumber
  federalTaxNumber
  poRequired
  poRequired
  shipToStates
  primaryContactPhone
  effectiveOrderEntryUnit
  contactSearchEntries {
    ...CustomerContactSearchEntry
  }
}
fragment CustomerContactSearchEntry on CustomerContactSearchEntry {
  contactId
  name
  phone
  phoneDigits
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCustomersByNamesDocument = new TypedDocumentString(`
    query GetCustomersByNames($names: [String!]!, $where: CustomersSummaryDocumentFilterInput, $order: [CustomersSummaryDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  customersByNames(
    names: $names
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      customerId
      name
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCustomerIdentitiesByNamesDocument = new TypedDocumentString(`
    query GetCustomerIdentitiesByNames($names: [String!]!, $order: [CustomersSummaryDocumentSortInput!], $first: Int, $after: String) {
  customersByNames(names: $names, order: $order, first: $first, after: $after) {
    nodes {
      customerId
      name
      customerTypeId
      erpId
      importId
      crmImportId
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCustomersTermsByIdsDocument = new TypedDocumentString(`
    query GetCustomersTermsByIds($where: CustomersSummaryDocumentFilterInput, $first: Int) {
  customers(where: $where, first: $first) {
    nodes {
      customerId
      termsId
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCustomersPoRequiredByIdsDocument = new TypedDocumentString(`
    query GetCustomersPoRequiredByIds($where: CustomersSummaryDocumentFilterInput, $first: Int) {
  customers(where: $where, first: $first) {
    nodes {
      customerId
      poRequired
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCustomerNamesForUserAdminDocument = new TypedDocumentString(`
    query GetCustomerNamesForUserAdmin($where: CustomersSummaryDocumentFilterInput, $first: Int) {
  customers(where: $where, first: $first) {
    nodes {
      customerId
      name
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCustomerDocument = new TypedDocumentString(`
    query GetCustomer($customerId: String!) {
  customer(customerId: $customerId) {
    ...Customer
  }
}
    fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}`);
export const GetCustomersForImportDocument = new TypedDocumentString(`
    query GetCustomersForImport($customerIds: [String!]!, $first: Int, $after: String) {
  customersForImport(customerIds: $customerIds, first: $first, after: $after) {
    nodes {
      customerId
      name
      currency
      description
      erpId
      erpPriceGroupId
      priceGroupId
      termsId
      customerTypeId
      route
      carrier
      allowOrderBillingAddressEdit
      allowOrderLocationAddressEdit
      freightChargeType
      freightChargeValue
      defaultDiscountPercentage
      taxExemptNumber
      federalTaxNumber
      poRequired
      synchronizeOrders
      customerLookupCode
      salesPeople {
        ...SalesPerson
      }
      locations {
        id
        code
        storeNumber
        name
        description
        region
        market
        adGroup
        globalLocationNumber
        locationLookupCode
        priceGroupId
        termsId
        route
        freightChargeType
        freightChargeValue
        sendOrderEmails
        sendInvoiceEmails
        poRequired
        address {
          ...Address
        }
        salesPeople {
          ...SalesPerson
        }
        settings {
          retailerName
          route
          shippingNotes
          storeClass
          zone
        }
      }
      billingAddresses {
        ...BillingAddresses
      }
      contacts {
        ...Contact
      }
      orderSubmitter {
        ...OrderSubmitter
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const GetCustomerOrderContactsForImportDocument = new TypedDocumentString(`
    query GetCustomerOrderContactsForImport($customerIds: [String!]!, $first: Int, $after: String) {
  customersForImport(customerIds: $customerIds, first: $first, after: $after) {
    nodes {
      customerId
      contacts {
        type
        emailAddresses {
          value
        }
        phoneNumbers {
          value
        }
      }
      orderSubmitter {
        phone
        email
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCustomersOwnBillingAddressForImportDocument = new TypedDocumentString(`
    query GetCustomersOwnBillingAddressForImport($customerIds: [String!]!, $first: Int, $after: String) {
  customersForImport(customerIds: $customerIds, first: $first, after: $after) {
    nodes {
      customerId
      hasOwnBillingAddress
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCustomersImportReadinessForErpDocument = new TypedDocumentString(`
    query GetCustomersImportReadinessForErp($customerIds: [String!]!, $first: Int, $after: String) {
  customersForImport(customerIds: $customerIds, first: $first, after: $after) {
    nodes {
      customerId
      hasOwnBillingAddress
      locations {
        id
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCustomerInvoiceRecipientsDocument = new TypedDocumentString(`
    query GetCustomerInvoiceRecipients($customerId: String!) {
  customerInvoiceRecipients(customerId: $customerId) {
    recipients
    fallbackReason
  }
}
    `);
export const CustomerLocationsDocument = new TypedDocumentString(`
    query customerLocations($first: Int, $after: String, $where: CustomerLocationDocumentFilterInput, $order: [CustomerLocationDocumentSortInput!]) {
  customerLocations(first: $first, after: $after, where: $where, order: $order) {
    totalCount
    pageInfo {
      ...PageInfo
    }
    nodes {
      ...CustomerLocationFields
    }
  }
}
    fragment CustomerLocationFields on CustomerLocationDocument {
  adGroup
  id
  tenantId
  customerId
  customerName
  customerLookupCode
  globalLocationNumber
  locationId
  locationLookupCode
  name
  code
  storeNumber
  region
  priceGroupId
  priceGroupName
  route
  termsId
  termsName
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  poRequired
  market
  region
  servicingSiteLocationId
  latitude
  longitude
  receivingEmail
  effectiveReceivingWindowStart
  effectiveReceivingWindowEnd
  address {
    ...AddressData
  }
  settings {
    deliveryScheduleId
    deliveryScheduleName
    retailerName
    route
    shippingNotes
    storeClass
    zone
    deliveryScheduleName
    deliveryScheduleId
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    contextNotes {
      context
      submitDate
      submittedBy
      text
    }
    ruleIds
    shippingNotes
  }
  customerLookupCode
  locationLookupCode
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const GetCustomerLocationsForSelectorDocument = new TypedDocumentString(`
    query GetCustomerLocationsForSelector($first: Int, $after: String, $where: CustomerLocationDocumentFilterInput, $order: [CustomerLocationDocumentSortInput!]) {
  customerLocations(first: $first, after: $after, where: $where, order: $order) {
    totalCount
    pageInfo {
      ...PageInfo
    }
    nodes {
      ...CustomerLocationSelectorFields
    }
  }
}
    fragment CustomerLocationSelectorFields on CustomerLocationDocument {
  id
  locationId
  name
  code
  locationLookupCode
  priceGroupName
  customerLookupCode
  customerName
  region
  storeNumber
  route
  latitude
  longitude
  address {
    ...AddressData
  }
  settings {
    deliveryScheduleId
    route
    storeClass
    zone
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const GetCustomerLocationNamesDocument = new TypedDocumentString(`
    query GetCustomerLocationNames($first: Int, $after: String, $where: CustomerLocationDocumentFilterInput, $order: [CustomerLocationDocumentSortInput!], $includeCombined: Boolean! = false) {
  customerLocations(
    first: $first
    after: $after
    where: $where
    order: $order
    includeCombined: $includeCombined
  ) {
    nodes {
      locationId
      name
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCustomerLocationsWithBaseRateOfSaleDocument = new TypedDocumentString(`
    query GetCustomerLocationsWithBaseRateOfSale($first: Int, $after: String, $where: CustomerLocationDocumentFilterInput, $order: [CustomerLocationDocumentSortInput!]) {
  customerLocationsWithBaseRateOfSale(
    first: $first
    after: $after
    where: $where
    order: $order
  ) {
    totalCount
    pageInfo {
      ...PageInfo
    }
    nodes {
      ...CustomerLocationSelectorFields
    }
  }
}
    fragment CustomerLocationSelectorFields on CustomerLocationDocument {
  id
  locationId
  name
  code
  locationLookupCode
  priceGroupName
  customerLookupCode
  customerName
  region
  storeNumber
  route
  latitude
  longitude
  address {
    ...AddressData
  }
  settings {
    deliveryScheduleId
    route
    storeClass
    zone
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const GetEffectiveDeliveryScheduleDocument = new TypedDocumentString(`
    query GetEffectiveDeliverySchedule($customerId: String!, $locationId: UUID) {
  effectiveDeliverySchedule(customerId: $customerId, locationId: $locationId) {
    ...EffectiveDeliveryScheduleFields
  }
}
    fragment EffectiveDeliveryScheduleFields on EffectiveDeliveryScheduleData {
  tier
  restrictionActive
  effectiveRoute
  deliveryScheduleId
  deliveryScheduleName
  sunday
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
}`);
export const GetCustomerMinimumFreightDocument = new TypedDocumentString(`
    query GetCustomerMinimumFreight($first: Int!, $where: CustomersSummaryDocumentFilterInput!) {
  customers(first: $first, where: $where) {
    nodes {
      customerId
      minimumFreightCharge
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCustomers: build.query<GetCustomersQuery, GetCustomersQueryVariables | void>({
      query: (variables) => ({ document: GetCustomersDocument, variables })
    }),
    GetCustomersByNames: build.query<GetCustomersByNamesQuery, GetCustomersByNamesQueryVariables>({
      query: (variables) => ({ document: GetCustomersByNamesDocument, variables })
    }),
    GetCustomerIdentitiesByNames: build.query<GetCustomerIdentitiesByNamesQuery, GetCustomerIdentitiesByNamesQueryVariables>({
      query: (variables) => ({ document: GetCustomerIdentitiesByNamesDocument, variables })
    }),
    GetCustomersTermsByIds: build.query<GetCustomersTermsByIdsQuery, GetCustomersTermsByIdsQueryVariables | void>({
      query: (variables) => ({ document: GetCustomersTermsByIdsDocument, variables })
    }),
    GetCustomersPoRequiredByIds: build.query<GetCustomersPoRequiredByIdsQuery, GetCustomersPoRequiredByIdsQueryVariables | void>({
      query: (variables) => ({ document: GetCustomersPoRequiredByIdsDocument, variables })
    }),
    GetCustomerNamesForUserAdmin: build.query<GetCustomerNamesForUserAdminQuery, GetCustomerNamesForUserAdminQueryVariables | void>({
      query: (variables) => ({ document: GetCustomerNamesForUserAdminDocument, variables })
    }),
    GetCustomer: build.query<GetCustomerQuery, GetCustomerQueryVariables>({
      query: (variables) => ({ document: GetCustomerDocument, variables })
    }),
    GetCustomersForImport: build.query<GetCustomersForImportQuery, GetCustomersForImportQueryVariables>({
      query: (variables) => ({ document: GetCustomersForImportDocument, variables })
    }),
    GetCustomerOrderContactsForImport: build.query<GetCustomerOrderContactsForImportQuery, GetCustomerOrderContactsForImportQueryVariables>({
      query: (variables) => ({ document: GetCustomerOrderContactsForImportDocument, variables })
    }),
    GetCustomersOwnBillingAddressForImport: build.query<GetCustomersOwnBillingAddressForImportQuery, GetCustomersOwnBillingAddressForImportQueryVariables>({
      query: (variables) => ({ document: GetCustomersOwnBillingAddressForImportDocument, variables })
    }),
    GetCustomersImportReadinessForErp: build.query<GetCustomersImportReadinessForErpQuery, GetCustomersImportReadinessForErpQueryVariables>({
      query: (variables) => ({ document: GetCustomersImportReadinessForErpDocument, variables })
    }),
    GetCustomerInvoiceRecipients: build.query<GetCustomerInvoiceRecipientsQuery, GetCustomerInvoiceRecipientsQueryVariables>({
      query: (variables) => ({ document: GetCustomerInvoiceRecipientsDocument, variables })
    }),
    customerLocations: build.query<CustomerLocationsQuery, CustomerLocationsQueryVariables | void>({
      query: (variables) => ({ document: CustomerLocationsDocument, variables })
    }),
    GetCustomerLocationsForSelector: build.query<GetCustomerLocationsForSelectorQuery, GetCustomerLocationsForSelectorQueryVariables | void>({
      query: (variables) => ({ document: GetCustomerLocationsForSelectorDocument, variables })
    }),
    GetCustomerLocationNames: build.query<GetCustomerLocationNamesQuery, GetCustomerLocationNamesQueryVariables | void>({
      query: (variables) => ({ document: GetCustomerLocationNamesDocument, variables })
    }),
    GetCustomerLocationsWithBaseRateOfSale: build.query<GetCustomerLocationsWithBaseRateOfSaleQuery, GetCustomerLocationsWithBaseRateOfSaleQueryVariables | void>({
      query: (variables) => ({ document: GetCustomerLocationsWithBaseRateOfSaleDocument, variables })
    }),
    GetEffectiveDeliverySchedule: build.query<GetEffectiveDeliveryScheduleQuery, GetEffectiveDeliveryScheduleQueryVariables>({
      query: (variables) => ({ document: GetEffectiveDeliveryScheduleDocument, variables })
    }),
    GetCustomerMinimumFreight: build.query<GetCustomerMinimumFreightQuery, GetCustomerMinimumFreightQueryVariables>({
      query: (variables) => ({ document: GetCustomerMinimumFreightDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCustomersQuery, useLazyGetCustomersQuery, useGetCustomersByNamesQuery, useLazyGetCustomersByNamesQuery, useGetCustomerIdentitiesByNamesQuery, useLazyGetCustomerIdentitiesByNamesQuery, useGetCustomersTermsByIdsQuery, useLazyGetCustomersTermsByIdsQuery, useGetCustomersPoRequiredByIdsQuery, useLazyGetCustomersPoRequiredByIdsQuery, useGetCustomerNamesForUserAdminQuery, useLazyGetCustomerNamesForUserAdminQuery, useGetCustomerQuery, useLazyGetCustomerQuery, useGetCustomersForImportQuery, useLazyGetCustomersForImportQuery, useGetCustomerOrderContactsForImportQuery, useLazyGetCustomerOrderContactsForImportQuery, useGetCustomersOwnBillingAddressForImportQuery, useLazyGetCustomersOwnBillingAddressForImportQuery, useGetCustomersImportReadinessForErpQuery, useLazyGetCustomersImportReadinessForErpQuery, useGetCustomerInvoiceRecipientsQuery, useLazyGetCustomerInvoiceRecipientsQuery, useCustomerLocationsQuery, useLazyCustomerLocationsQuery, useGetCustomerLocationsForSelectorQuery, useLazyGetCustomerLocationsForSelectorQuery, useGetCustomerLocationNamesQuery, useLazyGetCustomerLocationNamesQuery, useGetCustomerLocationsWithBaseRateOfSaleQuery, useLazyGetCustomerLocationsWithBaseRateOfSaleQuery, useGetEffectiveDeliveryScheduleQuery, useLazyGetEffectiveDeliveryScheduleQuery, useGetCustomerMinimumFreightQuery, useLazyGetCustomerMinimumFreightQuery } = injectedRtkApi;
